<template>
    <div>

        <div class="header bottom">

        </div>

        <el-steps :active="1" align-center class="steps">
            <el-step title="验证手机号"></el-step>
            <el-step title="填写账号信息" status="wait"></el-step>
            <el-step title="注册成功"></el-step>
        </el-steps>

        <div>
            <el-form :model="form" class="form">

                <el-form-item>
                    <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>


                <div style="display: flex">
                    <el-form-item style="flex: 1">
                        <el-input v-model="form.smsCode" placeholder="请输入验证码"></el-input>
                    </el-form-item>

                    <el-button @click.prevent="sendVerifyCode" class="send-verify-code-btn"
                               :disabled="sendButtonStatus">
                        {{smsCodeButtonText}}
                    </el-button>
                </div>


                <el-form-item>
                    <el-button type="primary" @click="submitForm" class="submit-btn">提交</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="divider"></div>
        <div class="footer">
            Copyright © 2012-2018 256.com 版权所有 沪ICP备11041704号-31 京ICP证070359号
        </div>
    </div>
</template>

<script>

    const resend = element => {
        console.log(element)

    }

    export default {
        name: "register_step_1",
        data() {
            return {
                labelPosition: "0",
                sendButtonStatus: false,
                smsCodeButtonText: "获取验证码",

                form: {
                    phone: "",
                    smsCode: ""
                }
            }
        },
        methods: {

            sendVerifyCode() {

                if (this.form.phone === "") {
                    alert("请填写手机号码!");
                    return;
                }

                this.$axios.get("/api/register/sendSmsCode", {params: {phone: this.form.phone}}).then((res) => {
                    if (res.code === 200) {
                        let num = 5
                        let timer = setInterval(() => {
                            num--;
                            this.smsCodeButtonText = num + "s后重新获取";
                            this.sendButtonStatus = false;
                            if (num === 0) {
                                this.smsCodeButtonText = "获取验证码";
                                this.sendButtonStatus = true;
                                clearInterval(timer)
                            }
                        }, 1000)
                    } else {
                        alert(res.msg)
                    }
                })
            },
            removeDomain() {

            },
            submitForm() {

                if (this.form.phone === "") {
                    alert("请填写手机号码!");
                    return;
                }

                if (this.form.smsCode === "") {
                    alert("请填写验证码!");
                    return;
                }

                this.$axios.get("/api/register/verifyCode", {
                    params: {
                        phone: this.form.phone,
                        smsCode: this.form.smsCode
                    }
                }).then((res) => {
                    if (res.code === 200) {
                        this.$notify({
                            title: '成功',
                            message: '验证码验证成功',
                            type: 'success'
                        });
                        this.$router.push("/regStep2")
                    } else {
                        alert(res.msg)
                    }
                })

            }
        }
    }
</script>

<style scoped>

    .header {
        width: 100%;
        height: 110px;
    }

    .steps {
        width: 400px;
        margin: 100px auto;
    }

    .form {
        width: 400px;
        margin: 80px auto 0;
    }

    .send-verify-code-btn {
        height: 40px;
        margin-left: 20px;
    }

    .submit-btn {
        width: 100%;
    }

    .bottom {
        border-bottom: 1px solid rgb(230, 230, 230);
    }

    .divider {
        margin: 150px auto 10px;
        width: 80%;
        height: 1px;
        background-color: rgb(230, 230, 230);
    }

    .footer {
        font-size: 12px;
        color: #999;
    }
</style>